<!-- by 7527189 2 0 -->
<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="关键词" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入产品名称" v-model="queryParam.accumulateParam"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="批次号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入批次号" v-model="queryParam.batchNumber"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="入库单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入入库单号" v-model="queryParam.number"></a-input>
                </a-form-item>
              </a-col>
              <!-- <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="仓库" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select placeholder="请选择仓库" v-model="queryParam.depotId">
                    <a-select-option v-for="(depot,index) in depotList" :value="depot.id" :key="index">
                      {{ depot.depotName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="产品编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入DI" v-model="queryParam.barCode"></a-input>
                </a-form-item>
              </a-col> -->
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a>
                </a-col>
              </span>
              <template v-if="toggleSearchStatus">

                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="入库时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-range-picker style="width:100%" v-model="queryParam.createTime" format="YYYY-MM-DD"
                                    :placeholder="['开始时间', '结束时间']" @change="onDateChange"
                                    :disabled-date="disabledStartDate"
                    />
                  </a-form-item>
                </a-col>
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="请选择状态" v-model="queryParam.enabled">
                      <a-select-option value="1">启用</a-select-option>
                      <a-select-option value="0">禁用</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col> -->
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="序列号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="有无序列号" v-model="queryParam.enableSerialNumber">
                      <a-select-option value="1">有</a-select-option>
                      <a-select-option value="0">无</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col> -->
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="批号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="有无批号" v-model="queryParam.enableBatchNumber">
                      <a-select-option value="1">有</a-select-option>
                      <a-select-option value="0">无</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col> -->
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="扩展信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input style="width: 100%" placeholder="请输入扩展信息查询" v-model="queryParam.materialOther"></a-input>
                  </a-form-item>
                </a-col> -->
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="基础重量" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input-number style="width: 100%" placeholder="请输入基础重量查询" v-model="queryParam.weight"></a-input-number>
                  </a-form-item>
                </a-col> -->
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="保质期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input-number style="width: 100%" placeholder="请输入保质期查询" v-model="queryParam.expiryNum"></a-input-number>
                  </a-form-item>
                </a-col> -->
                <!-- <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入备注查询" v-model="queryParam.remark"></a-input>
                  </a-form-item>
                </a-col> -->
              </template>

            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin-top: 5px">
          <a-button v-if="btnEnableList.indexOf(1) > -1" @click="handleAdd" type="primary" icon="plus">新增</a-button>
          <a-button v-if="btnEnableList.indexOf(1) > -1" @click="handleImportXls()" type="primary"
                    icon="import">导入</a-button>
           <a-button type="primary" icon="download" @click="$refs.exportConfirmDate.show(handleExportXls,'商品信息','old')">导出</a-button>
          <!-- <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="1" v-if="btnEnableList.indexOf(1)>-1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
              <a-menu-item key="2" v-if="btnEnableList.indexOf(1)>-1" @click="batchSetStatus(true)"><a-icon type="check-square" />启用</a-menu-item>
              <a-menu-item key="3" v-if="btnEnableList.indexOf(1)>-1" @click="batchSetStatus(false)"><a-icon type="close-square" />禁用</a-menu-item>
              <a-menu-item key="4" v-if="btnEnableList.indexOf(1)>-1" @click="batchEdit()"><a-icon type="edit" />批量编辑</a-menu-item>
              <a-menu-item key="5" v-if="btnEnableList.indexOf(1)>-1" @click="batchSetMaterialCurrentStock()"><a-icon type="stock" />修正库存</a-menu-item>
            </a-menu>
            <a-button>
              批量操作 <a-icon type="down" />
            </a-button>
          </a-dropdown> -->
        </div>
        <!-- table区域-begin -->
<!--       :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, columnWidth: '2%' }" -->
        <div>
          <a-table ref="intable" size="middle" bordered rowKey="id" :columns="columns" :dataSource="dataSource"
                   :pagination="ipagination"  :scroll="{ x: true }"  :loading="loading"

                   @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <a @click="handledetail(record)">查看</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                <a>删除</a>
              </a-popconfirm>
            </span>
            <!-- <span slot="nameTitle">
              名称
              <a-tooltip title="消费者进行防伪查询时展示的该产品的名称">
                <a-icon type="question-circle" />
              </a-tooltip>
            </span>
            <span slot="UDITitle">
              UDI名称
              <a-tooltip title="申报DI时的产品名称">
                <a-icon type="question-circle" />
              </a-tooltip>
            </span>
            <span slot="pTitle">
              产品名称
              <a-tooltip title="企业内部进行产品区分的名称">
                <a-icon type="question-circle" />
              </a-tooltip>
            </span> -->
            <template slot="customBarCode" slot-scope="text, record">
              {{ record.mBarCode }}
              <a-popover placement="right" trigger="click">
                <template slot="content">
                  <img :src='getImgUrl(record.imgName)' width="500px" />
                </template>
                <a-icon v-if="record.imgName" style="font-size: 18px" theme="twoTone" type="file-image" />
              </a-popover>
            </template>
            <template slot="Ctotal" slot-scope="text, record">
              <div class="box">
                <span class="text">{{ count(record.info) }}</span>
              </div>
            </template>
            <template slot="materialName" slot-scope="text, record">
              <div class="box" v-for="(it, idx) in record.info">
                <span class="text">{{ it.materialName }}</span>
                <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
              </div>
            </template>
            <template slot="barCode" slot-scope="text, record">
              <div class="box" v-for="(it, idx) in record.info">
                <span class="text">{{ it.barCode }}</span>
                <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
              </div>
            </template>
            <template slot="customnumber" slot-scope="text, record">
              <div class="box" v-for="(it, idx) in record.info">
                <!-- <a @click="numberDetail(it.uuid)" class="text">{{it.number}}</a> -->
                <span class="elementButtonText" @click="openNumberLook(record)">{{ it.number }}</span>
                <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
              </div>
            </template>
            <template slot="customrows" slot-scope="text, record">
              <div v-for="(it, idx) in record.info">
                <span>{{ it.quantity }}</span>
                <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
              </div>
            </template>
            <template slot="createTime" slot-scope="text, record">
              <span>{{ timestampToTime(record.createTime) }}</span>

              <!-- <div v-for="(it,idx) in record.info">
                <span>{{timestampToTime(it.createTime)}}</span>
                <a-divider v-if="record.info.length!=1&&idx!=record.info.length-1" />
              </div> -->
            </template>
            <template slot="CquantitySpec" slot-scope="text, record">
              <div v-for="(it, idx) in record.info">
                <span>{{ it.quantitySpec }}</span>
                <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
              </div>
            </template>
            <!-- <template slot="CdepotName" slot-scope="text, record">
              <div v-for="(it,idx) in record.info">
                <span>{{it.depotName}}</span>
                <a-divider v-if="record.info.length!=1&&idx!=record.info.length-1" />
              </div>
            </template> -->
            <template slot="CcreateBy" slot-scope="text, record">
              <div v-for="(it, idx) in record.info">
                <span>{{ it.createBy }}</span>
                <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
              </div>
            </template>
            <template slot="standard" slot-scope="text, record">
              <div v-for="(it, idx) in record.info">
                <span>{{ it.standard }}</span>
                <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
              </div>
            </template>
            <!-- <template slot="packSpec" slot-scope="text, record">
              <div v-if="record.packSpec&&record.packSpec.split(',')">
                <div v-for="it in record.packSpec.split( ','||'，')">{{ it.substring(9) ? it : ''}}</div>
              </div>
            </template> -->
            <!-- <template slot="customRenderStock" slot-scope="text, record">
              <a-tooltip :title="record.bigUnitStock">
                {{text}}
              </a-tooltip>
            </template>  -->
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <import-file-modal ref="modalImportForm" @ok="modalFormOk"></import-file-modal>
        <IndetailModel ref="IndetailModelref" @ok="modalFormOk"></IndetailModel>
        <UDIOutlistDialog ref="UDIOutlistDialog"></UDIOutlistDialog>
        <exportConfirmDate ref="exportConfirmDate" ></exportConfirmDate>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import IndetailModel from './modules/indetailModel'
import ImportFileModal from '@/components/tools/ImportFileModal'
// import BatchSetInfoModal from './modules/BatchSetInfoModal'
import { queryMaterialCategoryTreeList } from '@/api/api'
import { postAction, getFileAccessHttpUrl, getAction } from '@/api/manage'
import { getMpListShort } from '@/utils/util'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import JDate from '@/components/jeecg/JDate'
import Vue from 'vue'
import UDIOutlistDialog from './modules/UDIrukuDialog'
export default {
  name: 'MaterialList',
  mixins: [JeecgListMixin],
  components: {
    IndetailModel,
    ImportFileModal,
    JEllipsis,
    JDate,
    UDIOutlistDialog
  },
  data () {
    return {
      categoryTree: [],
      mPropertyListShort: '',
      model: {},
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 查询条件
      queryParam: {
        type: 0,
        accumulateParam: '',
        barCode: '',
        batchNumber: '',
        number: '',
        createTime: '',
      },
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '50', '100', '200'],
      },
      depotList: [],
      // 实际表头
      columns: [],
      // 初始化设置的表头
      settingColumns: [
        'batchNumber',
        'depotName',
        'materialName',
        'barCode',
        // 'pName',
        // 'udiName',
        'di',
        'total',
        'standard',
        'number',
        'quantity',
        'quantitySpec',
        'createByName',
        'createTime',
      ],
      // 默认的列
      defColumns: [
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   width: 100,
        //   scopedSlots: { customRender: 'action' },
        // },
        { title: '批次号', dataIndex: 'batchNumber', align: 'center', width: 80 },
        { title: '入库仓库', dataIndex: 'depotName', align: 'center', width: 80 },
        {
          title: '操作人', align: 'center',
          dataIndex: 'createByName',
          width: 100,
          // scopedSlots: { customRender: 'CcreateBy' },
        },
        {
          title: '入库时间', align: 'center',
          dataIndex: 'createTime',
          width: 130,
          scopedSlots: { customRender: 'createTime' },
        },
        // { title: '防伪名称', dataIndex: 'pName', width: 100 },
        // { title: 'UDI名称', dataIndex: 'udiName', width: 100 },
        // { title: '规格', dataIndex: 'standard', width: 100 },
        { title: '产品总数', dataIndex: 'total', width: 70, align: 'center', scopedSlots: { customRender: 'Ctotal' } },
        { title: '产品名称', dataIndex: 'materialName', align: 'center', width: 100, scopedSlots: { customRender: 'materialName' } },
        { title: '产品编码', dataIndex: 'barCode', align: 'center', width: 100, scopedSlots: { customRender: 'barCode' } },
        { title: '规格', dataIndex: 'standard', align: 'center', width: 120, scopedSlots: { customRender: 'standard' } },
        { title: '入库单号', dataIndex: 'number', align: 'center', width: 130, scopedSlots: { customRender: 'customnumber' } },
        {
          title: '入库数量',
          dataIndex: 'quantity',
          width: 70,
          align: 'center',
          scopedSlots: { customRender: 'customrows' },
        },
        {
          title: '包装数量',
          dataIndex: 'quantitySpec', align: 'center',
          width: 250,
          scopedSlots: { customRender: 'CquantitySpec' },
        },
        // {
        //   title: '入库仓库',
        //   dataIndex: 'depotName',
        //   width: 80,
        //   scopedSlots: { customRender: 'CdepotName' },
        // },

        // { title: '品类编码', dataIndex: 'cName', width: 100 },
        // { title: '颜色', dataIndex: 'color', width: 70, ellipsis: true },
        // { title: '类别', dataIndex: 'categoryName', width: 100, ellipsis: true },
        // { title: '扩展信息', dataIndex: 'materialOther', width: 100, ellipsis: true },
        // {
        //   title: '单位',
        //   dataIndex: 'unit',
        //   width: 100,
        //   ellipsis: true,
        //   customRender: function (t, r, index) {
        //     if (r) {
        //       let name = t ? t : r.unitName
        //       if (r.sku) {
        //         return name + '[SKU]'
        //       } else {
        //         return name
        //       }
        //     }
        //   },
        // },
        // { title: '基础重量', dataIndex: 'weight', width: 80 },
        // { title: '保质期', dataIndex: 'expiryNum', width: 60 },
        // { title: '库存', dataIndex: 'stock', width: 80, scopedSlots: { customRender: 'customRenderStock' } },
        // { title: '采购价', dataIndex: 'purchaseDecimal', width: 80 },
        // { title: '零售价', dataIndex: 'commodityDecimal', width: 80 },
        // { title: '销售价', dataIndex: 'wholesaleDecimal', width: 80 },
        // { title: '最低售价', dataIndex: 'lowDecimal', width: 80 },
        // { title: '备注', dataIndex: 'remark', width: 80 },
        // {
        //   title: '状态',
        //   dataIndex: 'enabled',
        //   align: 'center',
        //   width: 60,
        //   scopedSlots: { customRender: 'customRenderEnabled' },
        // },
      ],
      url: {
        list: '/accumulate/list',
        delete: '/material/delete',
        deleteBatch: '/material/deleteBatch',
        importExcelUrl: '/material/importExcel',
        exportXlsUrl: '/saleRecordAcc/exportExcelInStorage',
        batchSetStatusUrl: '/material/batchSetStatus',
        batchSetMaterialCurrentStockUrl: '/material/batchSetMaterialCurrentStock',
      },
    }
  },
  created () {
    this.initColumnsSetting()
    // this.loadTreeData()
    this.getDepotData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}${this.url.importExcelUrl}`
    },
  },
  methods: {
    disabledStartDate(current) {
      // 创建表示 2024 年 7 月 10 日的日期对象
      const disabledDate = new Date(2024, 6, 11); // 注意月份从 0 开始

      // 如果日期早于 2024 年 7 月 10 日，则禁用该日期
      return current && current > disabledDate;
    },
    openNumberLook (record) {
      this.$refs.UDIOutlistDialog.add(record.number, '入库')
    },
    getDepotData () {
      getAction('/depot/findDepotByCurrentUser').then((res) => {
        if (res.code === 200) {
          this.depotList = res.data
        } else {
          this.$message.info(res.data)
        }
      })
    },
    numberDetail (uuid) {
      console.log(uuid, 'uuid')
      this.$refs.modaltree.show(uuid)
    },
    count (arr) {
      let num = 0
      arr.forEach((it) => {
        num += Number(it.quantity)
      })
      return num
    },
    handledetail () {
      this.$refs.IndetailModelref.add()
    },
    onDateChange: function (value, dateString) {
      this.queryParam.beginTime = dateString[0]
      this.queryParam.endTime = dateString[1]
    },
    //加载初始化列
    initColumnsSetting () {
      let columnsStr = Vue.ls.get('intable')
      if (columnsStr && columnsStr.indexOf(',') > -1) {
        this.settingColumns = columnsStr.split(',')
      }
      this.columns = this.defColumns.filter((item) => {
        if (this.settingColumns.includes(item.dataIndex)) {
          return true
        }
        return false
      })
    },

    loadTreeData () {
      let that = this
      let params = {}
      params.id = ''
      queryMaterialCategoryTreeList(params).then((res) => {
        if (res) {
          that.categoryTree = []
          for (let i = 0; i < res.length; i++) {
            let temp = res[i]
            that.categoryTree.push(temp)
          }
        }
      })
    },
    batchSetMaterialCurrentStock () {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
      } else {
        let ids = ''
        for (let a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        let that = this
        
        this.$confirm('是否操作选中数据?', '确认操作', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          that.loading = true
            postAction(that.url.batchSetMaterialCurrentStockUrl, { ids: ids })
              .then((res) => {
                if (res.code === 200) {
                  that.$message.info('修正库存成功!')
                  that.loadData()
                  that.onClearSelected()
                } else {
                  that.$message.warning(res.data.message)
                }
              })
              .finally(() => {
                that.loading = false
              })
        }).catch(() => {});
      }
    },
    batchEdit () {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
      } else {
        let ids = ''
        for (let a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        this.$refs.batchSetInfoModalForm.edit(ids)
        this.$refs.batchSetInfoModalForm.title = '批量编辑'
      }
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
      this.$refs.modalForm.disableSubmit = false
      if (this.btnEnableList.indexOf(1) === -1) {
        this.$refs.modalForm.isReadOnly = true
      }
    },
    getImgUrl (imgName) {
      if (imgName && imgName.split(',')) {
        return getFileAccessHttpUrl('systemConfig/static/' + imgName.split(',')[0])
      } else {
        return ''
      }
    },
    handleImportXls () {
      let importExcelUrl = this.url.importExcelUrl
      let templateUrl = '/doc/goods_template.xls'
      let templateName = '商品Excel模板[下载]'
      this.$refs.modalImportForm.initModal(importExcelUrl, templateUrl, templateName)
      this.$refs.modalImportForm.title = '商品导入'
    },
    searchReset () {
      this.queryParam = {
        type: 0,
        accumulateParam: '',
        barCode: '',
        batchNumber: '',
        number: '',
        createTime: '',
      }
      this.loadData(1)
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';

.elementButtonText {
  color: #409eff;
  cursor: pointer;
}
</style>